export const CLIENT_TYPE_MODAL_NAME = 'clientType';
